package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 顶层可复用动画定义。
 */
data class AnimationAst(
    val id: String,
    val node: Node,
    override val position: SourcePosition,
) : AstNode {

    enum class Kind {
        TRANSITION,
        KEYFRAME,
        SEQUENCE,
        PARALLEL,
        STAGGER,
        /**
         * 贝塞尔路径过渡：在动画块内通过 p0x/p0y/p1x/p1y/p2x/p2y[/p3x/p3y] 等
         * 字面量声明控制点，运行时按当前进度采样曲线并驱动 translateX/translateY。
         */
        PATH_TRANSITION,
    }

    data class Node(
        val kind: Kind,
        val durationMs: Double?,
        val durationPosition: SourcePosition?,
        val delayMs: Double?,
        val delayPosition: SourcePosition?,
        val staggerMs: Double?,
        val staggerPosition: SourcePosition?,
        val easing: String?,
        val easingPosition: SourcePosition?,
        val loopMode: String?,
        val loopModePosition: SourcePosition?,
        val props: List<PropAssign>,
        val keyframes: List<Keyframe>,
        val children: List<Node>,
        /** 弹簧物理参数子块：null=用 easing 驱动；非空=改用弹簧求解器驱动过渡。 */
        val spring: SpringAst? = null,
        override val position: SourcePosition,
    ) : AstNode

    /**
     * 弹簧物理参数子块（`spring { stiffness = ... damping = ... mass = ... initialVelocity = ... }`）。
     *
     * 各参数可缺省，缺省时由 emit 阶段填入 [top.wcpe.allincore.dsl.ir.model.animation.SpringSpec] 的默认值。
     */
    data class SpringAst(
        val stiffness: Double?,
        val damping: Double?,
        val mass: Double?,
        val initialVelocity: Double?,
        override val position: SourcePosition,
    ) : AstNode

    data class Keyframe(
        val offset: Double,
        val props: List<PropAssign>,
        override val position: SourcePosition,
    ) : AstNode

    data class PropAssign(
        val name: String,
        val value: ExprAst,
        val position: SourcePosition,
    )
}
